import styled from "styled-components";
import { breakpoint, NAMESPACE } from "@m/alchemy-theme";
import { gutterSizes } from "../Grid.utils";
import { Col as StyledCol } from "../col/Col.styled";
const justifyStyles = {
    start: "justify-content: flex-start; text-align: start;",
    center: "justify-content: center; text-align: center;",
    end: "justify-content: flex-end; text-align: end;",
    around: "justify-content: space-around;",
    between: "justify-content: space-between;"
};
const getMarginOffset = (margin) => {
    const marginOffset = typeof margin === "number" ? `${margin}px` : gutterSizes[margin];
    return margin ? `margin: 0 -${marginOffset};` : "";
};
const getWidthStyle = (width) => (width ? `padding-left:${width}; padding-right:${width}; ` : "");
const gutterCalc = (size) => {
    if (typeof size === "number") {
        return getWidthStyle(`${size}px`);
    }
    return getWidthStyle(gutterSizes[size]);
};
const insertRowMediaQueries = (gutter, theme, allBreakpoints) => {
    // with context
    if (allBreakpoints && typeof gutter !== "string" && typeof gutter !== "number") {
        return Object.entries(allBreakpoints)
            .sort((a, b) => a[1] - b[1])
            .map(([breakpointKey]) => {
            const gutterBreakpoint = gutter[breakpointKey];
            return `@media all and (min-width: ${allBreakpoints[breakpointKey]}px) { ${getMarginOffset(gutterBreakpoint)}; }`;
        });
    }
    // without context
    if (typeof gutter === "number" || typeof gutter === "string" || gutter === null) {
        return "";
    }
    return Object.entries(gutter).map(([key, value]) => {
        const themeBreakpoints = theme[NAMESPACE].breakpoints;
        return key in themeBreakpoints
            ? `
        @media all and (min-width: ${breakpoint(key)({ theme })}px) {
          ${getMarginOffset(value)};
        }
      `
            : "";
    });
};
const insertColMediaQueries = (gutter, theme, allBreakpoints) => {
    // with context
    if (allBreakpoints && typeof gutter === "object") {
        return Object.entries(allBreakpoints)
            .sort((a, b) => a[1] - b[1])
            .map((entry) => {
            const key = entry[0];
            return `@media all and (min-width: ${allBreakpoints[key]}px) { ${gutterCalc(gutter[key])}; }`;
        });
    }
    // without context
    if (typeof gutter === "number" || typeof gutter === "string" || gutter === null) {
        return "";
    }
    return Object.entries(gutter).map(([key, value]) => {
        const themeBreakpoints = theme[NAMESPACE].breakpoints;
        return key in themeBreakpoints
            ? `
        @media all and (min-width: ${breakpoint(key)({ theme })}px) {
          ${gutterCalc(value)};
        }
      `
            : "";
    });
};
export const Row = styled.div `
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-flow: row wrap;
  ${({ gutter }) => {
    if (typeof gutter === "number" || typeof gutter === "string") {
        return getMarginOffset(gutter);
    }
    if (gutter !== undefined && gutter !== null && gutter.small !== undefined) {
        return getMarginOffset(gutter.small);
    }
    return getMarginOffset("medium");
}};
  ${({ isReversed }) => (isReversed ? "flex-direction: row-reverse;" : "")}
  ${({ align }) => (align ? `align-items: ${align};` : "")}
  ${({ justify }) => (justify && justifyStyles[justify] ? justifyStyles[justify] : "")}

  ${({ breakpoints, gutter, theme }) => gutter === undefined ? "" : insertRowMediaQueries(gutter, theme, breakpoints)};

  ${StyledCol} {
    ${({ gutter }) => {
    if (typeof gutter === "number" || typeof gutter === "string") {
        return gutterCalc(gutter);
    }
    return gutter !== undefined && gutter !== null && gutter.small !== undefined
        ? gutterCalc(gutter.small)
        : gutterCalc("medium");
}}

    ${({ breakpoints, gutter, theme }) => gutter !== undefined && gutter !== null ? insertColMediaQueries(gutter, theme, breakpoints) : ""};
  }
`;
export const rowDefaultProps = {
    gutter: "medium",
    isReversed: false
};
Row.defaultProps = rowDefaultProps;
